import { CAMEL_TO_KEBAB } from './theme-config'
import type {
  EditableThemeTokenName,
  EditableThemeTokensByVariant,
} from './theme-config'

const KEBAB_TO_CAMEL: Record<EditableThemeTokenName, string> =
  Object.fromEntries(
    Object.entries(CAMEL_TO_KEBAB).map(([camel, kebab]) => [kebab, camel]),
  )

export function mapKebabTokensToCamel(
  tokens: EditableThemeTokensByVariant,
): Record<string, Record<string, string>> {
  return {
    light: Object.fromEntries(
      Object.entries(tokens.light).map(
        ([key, value]) =>
          [KEBAB_TO_CAMEL[key as EditableThemeTokenName], value] as const,
      ),
    ),
    dark: Object.fromEntries(
      Object.entries(tokens.dark).map(
        ([key, value]) =>
          [KEBAB_TO_CAMEL[key as EditableThemeTokenName], value] as const,
      ),
    ),
  }
}
